import React from 'react'
import cx from 'classnames'

import { AtsLockContext } from 'components/common/AtsLock'
import { Icon } from 'components/shared/Icon/Icon'
import { LockMessage } from 'components/shared/LockMessage/LockMessage'
import { DropdownHandlersContext } from './../../context'

import { useTooltip } from 'hooks'

import { LockIcon } from 'components/shared/Icon/model'

import styles from './Action.module.scss'

export const Action = ({
  children,
  className = undefined,
  onClick,
  isDisabled,
  isLocked,
}) => {
  const { onDismiss } = React.useContext(DropdownHandlersContext)
  const { owner } = React.useContext(AtsLockContext) ?? {}

  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip({ initialPlacement: 'left' })

  const handleActionClick = React.useCallback(() => {
    if (onClick) {
      onClick()
    }

    onDismiss()
  }, [onClick, onDismiss])

  return (
    <>
      <button
        className={cx(styles.action, { [className]: Boolean(className) })}
        ref={reference}
        onClick={handleActionClick}
        disabled={isLocked || isDisabled}
        {...(isLocked && {
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onPointerEnter: handleMouseEnter,
          onPointerLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        })}
      >
        <span className={styles.content}>
          {isLocked ? (
            <Icon className={styles.lock} icon={LockIcon} size={16} />
          ) : null}
          {children}
        </span>
      </button>
      {isLocked ? (
        <LockMessage
          {...{
            arrowRef,
            arrowStyle,
            floating,
            floatingStyle,
            owner,
            hasArrow,
            isToggled,
          }}
        />
      ) : null}
    </>
  )
}
